import React from 'react';

import * as S from './HeaderNavigation.styles';

const HeaderUI = () => {
    return (
        <S.Header>
        </S.Header>
    );
};

export default HeaderUI;
